import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'ButtonBarSkeleton',
  values: {
    numberOfButtons: 4,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '4px',
        },
      },
    },
    buttonSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '80px',
          height: '40px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
